import {EventTypeOption, EventVenue} from 'api/events/events.types';
import {EventFilterOption} from './event-management.types';

const formatEventFilterOptions = (
    data: (EventTypeOption | EventVenue)[]
): EventFilterOption[] => {
    const formattedData = data.map((item) => ({
        label: item.title,
        value: item.title,
        id: item.id ? item.id.toString() : '',
    }));

    return formattedData;
};

export default formatEventFilterOptions;
